import PersonIcon from '@material-ui/icons/Person';
export const NaamIcon = PersonIcon;

